import { render } from "./categoryMenu.vue?vue&type=template&id=36da6d4f&scoped=true"
import script from "./categoryMenu.vue?vue&type=script&lang=js"
export * from "./categoryMenu.vue?vue&type=script&lang=js"

import "./categoryMenu.vue?vue&type=style&index=0&id=36da6d4f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36da6d4f"]])

export default __exports__